<div class="page-container">

  <div class="hero-wrapper flex align-items-center relative overflow-hidden">
    <div
      class="hero-intro relative z-2 flex flex-column justify-content-center px-3 md:pr-5 md:pl-6"
    >
      <h1 class="hero-intro__title m-0">
        <p class="text-nowrap m-0">Make It Ridiculously</p>
        <span>Easy To Refer You</span>
      </h1>
      <p class="hero-intro__subtitle mt-3">
        PitchCards are the world’s most powerful tool to get referrals,
        introductions and network in a more human way.
      </p>
      <div class="hero-intro__actions flex flex-wrap align-items-center gap-3 mt-5">
        <button
          type="button"
          class="hero-intro__btn hero-intro__btn--primary"
          (click)="moveToCreate()"
        >
          Create Free PitchCard
        </button>
        <button
          type="button"
          class="hero-intro__btn hero-intro__btn--ghost"
          (click)="openDemoDialog()"
        >
          Watch Demo Now
        </button>
      </div>
    </div>

    @if (heroLayoutReady) {
      @if(!isMobile && !isTablet)
      {
      <div class="relative z-2 flex-1 box-shadow mx-10 overflow-hidden max-w-40">
        <div class="video-column left-col">
          <div class="video-column__track video-column__track--down">
            @for (copy of [0, 1]; track copy) {
              <div class="video-column__set" [attr.aria-hidden]="copy === 1">
                @for (placeholder of leftVideoColumn; track $index) {
                  <div
                    class="video-wrapper"
                    [class.video-wrapper--ready]="isHeroVideoReady('left', copy, $index)"
                  >
                    <img
                      class="video-placeholder"
                      [src]="placeholder"
                      alt=""
                    />
                    <video
                      autoplay
                      #heroVideo
                      muted
                      loop
                      playsinline
                      preload="none"
                      [controls]="false"
                      [poster]="placeholder"
                      (canplay)="onHeroVideoCanPlay($event, 'left', copy, $index)"
                      (playing)="onHeroVideoReady('left', copy, $index)"
                    >
                      <source [attr.data-src]="`https://pitch59-dev.s3.us-east-1.amazonaws.com/landing_videos/landing${$index + 1}_comp.webm`" />
                    </video>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="video-column right-col">
          <div class="video-column__track video-column__track--up">
            @for (copy of [0, 1]; track copy) {
              <div class="video-column__set" [attr.aria-hidden]="copy === 1">
                @for (placeholder of rightVideoColumn; track $index) {
                  <div
                    class="video-wrapper"
                    [class.video-wrapper--ready]="isHeroVideoReady('right', copy, $index)"
                  >
                    <img
                      class="video-placeholder"
                      [src]="placeholder"
                      alt=""
                    />
                    <video
                      autoplay
                      #heroVideo
                      muted
                      loop
                      playsinline
                      preload="none"
                      [controls]="false"
                      [poster]="placeholder"
                      (canplay)="onHeroVideoCanPlay($event, 'right', copy, $index)"
                      (playing)="onHeroVideoReady('right', copy, $index)"
                    >
                      <source [attr.data-src]="`https://pitch59-dev.s3.us-east-1.amazonaws.com/landing_videos/landing${$index + 7}_comp.webm`" />
                    </video>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    } @else
    {
      <div class="video-marquee relative z-2 box-shadow overflow-hidden">
        <div class="video-marquee__track">
          @for (copy of [0, 1]; track copy) {
            <div class="video-marquee__set" [attr.aria-hidden]="copy === 1">
              <!-- heroVideoPlaceholders -->
              @for (placeholder of leftVideoColumn; track $index) {
                <div
                  class="video-wrapper"
                  [class.video-wrapper--ready]="isHeroVideoReady('row', copy, $index)"
                >
                  <img
                    class="video-placeholder"
                    [src]="placeholder"
                    alt=""
                  />
                  <video
                    autoplay
                    #heroVideo
                    muted
                    loop
                    playsinline
                    preload="none"
                    [controls]="false"
                    [poster]="placeholder"
                    (canplay)="onHeroVideoCanPlay($event, 'row', copy, $index)"
                    (playing)="onHeroVideoReady('row', copy, $index)"
                  >
                    <source [attr.data-src]="`https://pitch59-dev.s3.us-east-1.amazonaws.com/landing_videos/landing${$index + 1}_comp.webm`" />
                  </video>
                </div>
              }
            </div>
          }
        </div>
      </div>
      }
    }

    @if (partnersListUrls?.length) {
      <div class="partners-bar">
        <div class="partners-scroll">
          @for (copy of [0, 1, 2]; track copy) {
            <div class="partners-set" [attr.aria-hidden]="copy > 0">
              @for (partner of partnersListUrls; track partner.url) {
                <img
                  [ngSrc]="partner.url"
                  [alt]="partner.title"
                  width="120"
                  height="60"
                  loading="eager"
                />
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

    <section id="slider-video" class="slider-video-section">
      <div class="pattern pattern-top-left"></div>
      <div class="pattern pattern-right-center"></div>
      <div class="slider-video-layout">
        <div class="slider-video">
          @if (muxDemoVideoId) {
            <app-player-mux
              [id]="'demo-video'"
              [showAutoplayOverlay]="true"
              [muxVideoId]="muxDemoVideoId"
              [aspectRatio]="9 / 18.4"
              [autoplay]="true"
            ></app-player-mux>
          }
        </div>
        @if (sliderList && sliderList.length) {
        <div class="slider-video-benefits">
          <h2>{{ sliderSectionTitle }}</h2>
          <div class="benefits-scrollbar-container">
            <div
              class="benefits-scrollbar-content"
              #scrollContent
              (scroll)="onScroll()"
            >
              <div class="benefits-list">
                @for (benefit of sliderList; track $index) {
                  <div
                    class="benefit-card"
                    [class.active]="activeVideo === $index"
                    (click)="moveToSlide($index)"
                    #benefitCard
                  >
                    <div class="benefit-title">{{ benefit.title }}</div>
                    <div class="benefit-desc">{{ benefit.subtitle }}</div>
                  </div>
                }
              </div>
            </div>
            @if (false) {
              <div class="benefits-scrollbar-track">
                <div
                  class="benefits-scrollbar-thumb"
                  [ngStyle]="thumbStyle"
                  (mousedown)="onThumbMouseDown($event)"
                ></div>
              </div>
            }
          </div>
          <div class="benefits-cta flex-row-to-column">
            <button class="btn primary" (click)="moveToCreate()">
              Create PitchCard
            </button>
            <button
              class="btn btn-outline demo-btn-outline"
              (click)="openDemoDialog()"
            >
              Watch Demo Now
            </button>
          </div>
        </div>
        }
      </div>
    </section>

    <section class="performance">
      <div class="performance-item">
        <span class="performance-value">5</span>
        <span class="performance-label"
        >New home listings in the first month</span
        >
        <span class="performance-meta">Jessica, Exit Realty</span>
      </div>
      <div class="performance-item">
        <span class="performance-value">17</span>
        <span class="performance-label">New referrals in the first day</span>
        <span class="performance-meta">Sales Xceleration</span>
      </div>
      <div class="performance-item">
        <span class="performance-value">$19K</span>
        <span class="performance-label">In new business from 1 referral</span>
        <span class="performance-meta">AC Ninja</span>
      </div>
    </section>

    <!-- TESTIMONIALS SECTION -->
    <section class="testimonials">
      <h2>Client Testimonials</h2>
      <app-review-list></app-review-list>
    </section>

    <!-- HOW-TO SECTION -->
    <section id="howto-section" class="howto">
      <h2>Your PitchCard: From Setup To Success</h2>
      <p>
        Learn how to create, personalize, and grow your business with a PitchCard.
      </p>
      <div class="howto-grid">
        @for (video of howtoVideos; track video.videoUrl) {
          <div class="howto-item">
            <div class="howto-title-bar">
              <div class="howto-title">{{ video.title }}</div>
            </div>
            <div class="howto-video-preview">
              @if (!video.isPlaying) {
                <img
                  [ngSrc]="video.image"
                  alt="Video preview"
                  width="400"
                  height="225"
                  class="howto-image"
                  (click)="playHowtoVideo($index)"
                  loading="lazy"
                />
                <img
                  [ngSrc]="video.playIcon"
                  alt="Play video"
                  width="80"
                  height="80"
                  class="howto-play-icon"
                  (click)="playHowtoVideo($index)"
                  loading="lazy"
                />
              }
              @if (video.isPlaying) {
                <div
                  class="video-container"
                  (click)="enableVideoSound($index)"
                >
                  <app-player-mux
                    [id]="'howto-player-' + $index"
                    [muxVideoId]="video.videoUrl"
                    [autoplay]="false"
                    [muted]="false"
                    [aspectRatio]="16 / 9"
                    (ended)="onHowtoVideoEnded($index)"
                  >
                  </app-player-mux>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </section>

    <!-- WHY PITCHCARD SECTION -->
    <section class="why-pitchcard">
      <div class="why-bg"></div>
      <h2>Why Should I Get A PitchCard?</h2>
      <div class="why-list">
        @for (item of whyPitchcardItems; track item.title) {
          <div class="why-item">
            <img
              [ngSrc]="item.image"
              [alt]="item.alt"
              width="177"
              height="177"
              class="why-icon"
              loading="lazy"
            />
            <div class="why-content">
              <div class="why-title">{{ item.title }}</div>
              <div class="why-desc">{{ item.desc }}</div>
            </div>
          </div>
        }
      </div>
    </section>

    <div class="mb-8 pb-8 pt-8 mt-8 relative">
      <div class="pattern pattern-bottom-left"></div>
      <div class="pattern pattern-top-right"></div>
      <h2 class="faq-header">Frequently Asked Questions</h2>
      <app-faq
        class="z-1 relative"
        [isMobile]="isMobile"
        [landingType]="landingType"
      ></app-faq>
    </div>

    @if (landingType !== 2) {
      <section class="blog">
        <h2>Blog Articles</h2>
        <div class="blog-grid">
          @for (blog of blogList; track blog.title) {
            <div
              class="blog-card"
              [class.large]="$index === 0"
              [class.small]="$index > 0"
            >
              <picture class="blog-picture">
                @if (blog.mobileImage) {
                  <source
                    media="(max-width: 700px)"
                    [srcset]="blog.mobileImage"
                  />
                }
                <img
                  [ngSrc]="blog.image"
                  [alt]="blog.title"
                  width="400"
                  height="225"
                  class="blog-img"
                  loading="lazy"
                />
              </picture>
              <div class="blog-content">
                <h3>{{ blog.title }}</h3>
                <p>{{ blog.description }}</p>
                <a [href]="blog.url" target="_blank" class="read-more">
                  Read More
                  <svg
                    width="14"
                    height="14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 7h8m0 0-3-3m3 3-3 3"
                      stroke="#25AFB5"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          }
        </div>
      </section>
    }
  </div>

  <p-dialog
    appendTo="body"
    [(visible)]="isDemoDialogVisible"
    [modal]="true"
    [blockScroll]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="true"
    [style]="{ width: '70vw', maxWidth: '70vw' }"
    styleClass="video-player-dialog landing-demo-dialog"
    (onHide)="onDemoDialogHide()"
  >
    @if (isDemoDialogVisible) {
        <video
          class="landing-demo-dialog__video"
          controls
          autoplay
          playsinline
          [src]="demoVideoUrl"></video>
     
    }
  </p-dialog>
